import axios from 'axios';
import { UrlService } from '@sm360/widget-commons-core-services';

/**
 * Get User tracking information
 */

const config = {
    headers: { authorization: `Basic c20zNjA6c20zNjA=` },
};

class TrackingService {
    constructor() {
        this.trackingBasePath = `${UrlService.getUrlOrigin()}/tracking`;
    }

    async getSessionTrackingPath() {
        try {
            const response = await axios.get(this.trackingBasePath, config);
            if (response) {
                const apiResponse = response?.data || [];
                let trackingPaths = [];
                if (apiResponse && apiResponse.length > 0) {
                    trackingPaths = apiResponse.map((data) => {
                        return {
                            path: data.url,
                            pathDate: data.date,
                        };
                    });
                    return trackingPaths;
                }
            }
            return [];
        } catch (e) {
            return console.log('error');
        }
    }
}

export default new TrackingService();
